<template>
  <div class="eds-copyright">
    <div class="eds-copyright-text">
      <span>{{ $t('杭州数络信息技术有限公司') }}</span><span>{{ $t('版权所有') }}</span>
    </div>
    <div class="eds-copyright-text">
      <span>Copyright ©️ 2020-2022 hzdatalink.com</span><span>All Rights Reserved.</span>
    </div>
    <div v-if="beian" class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ $t('浙ICP备15035730号-1') }}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    beian: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
.eds-copyright {
  color: #a6a6a6;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  width: 100%;
  padding: 10px 40px;

  &>.eds-copyright-text {
    word-break: break-all;

    &>span {
      white-space: nowrap;

      &:nth-child(n + 2) {
        margin-left: 4px;
      }
    }
  }

  &>.beian {
    margin-top: 8px;
  }
}
</style>
